import React from 'react';
import { __ } from '../../helpers/TranslationService';

interface Props {
    phoneNumber: string;
    contactPagePath: string;
    firstLine: string;
    secondLine?: string;
}

export const ContactBlock = ({ phoneNumber, contactPagePath, firstLine, secondLine }: Props) => {
    return (
        <div className="globalPageheader_officeHoursWrapper text-right">
            <a
                href={contactPagePath}
                title={__('Call your Cruise Consultant', 'dreamlines')}
                className="globalPageheader_contact"
            >
                <address>
                    <div
                        className="globalPageheader_phone icon-handset-rounded"
                        dangerouslySetInnerHTML={{ __html: phoneNumber }}
                        data-test-id="header-phone"
                    />
                    <div
                        className="globalPageheader_officeHours"
                        dangerouslySetInnerHTML={{ __html: firstLine }}
                    />
                    {secondLine && (
                        <div
                            className="globalPageheader_officeHours"
                            dangerouslySetInnerHTML={{ __html: secondLine }}
                        />
                    )}
                </address>
            </a>
        </div>
    );
};
